import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { List, AddApi, EditApi } from '../interfaces/invoice.interface';

const list = (payload: List) => {
  const { startDate, endDate, property, customer, invoiceStatus, createdBy, reviewedBy, searchText, isVerified, managedBy, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listInvoices}?${queryString.stringify(paging)}`;
  return http.post(url, {
    search: searchText,
    property_id: property,
    start_date: startDate,
    end_date: endDate,
    customer_id: customer,
    invoice_status: invoiceStatus,
    created_by: createdBy,
    reviewed_by: reviewedBy,
    is_verified: isVerified,
    managed_by: managedBy
  });
};

const add = (payload: AddApi) => {
  return http.post(API_ENDPOINTS.invoices, payload);
}

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.invoices}/${id}`);
}

const preview = (id: string) => {
  return http.get(API_ENDPOINTS.invoicePreview(id));
}

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupInvoice}?${queryString.stringify({ search: payload.searchText || '', is_active: payload.is_active })}`;
  return http.get(url);
};

const edit = (id: string, payload: EditApi) => {
  return http.put(`${API_ENDPOINTS.invoices}/${id}`, payload);
};

const remove = (id: string) => {
  return http.delete(`${API_ENDPOINTS.invoices}/${id}`);
};

const complete = (id: string) => {
  return http.post(API_ENDPOINTS.invoiceComplete, { invoice_id: id });
};

const sendEmail = (id: string) => {
  return http.post(API_ENDPOINTS.invoiceSendEmail(id));
};

const InvoiceService = {
  list,
  add,
  get,
  lookup,
  edit,
  preview,
  remove,
  complete,
  sendEmail
};

export default InvoiceService;


